import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-vornamen',
    templateUrl: './input-field.component.html'
} )
export class FirstnameComponent extends AbstractFieldComponent<string>   {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.firstname' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.firstname = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.firstname;
    }
}
